import { Space, Row, Col, Button, Modal } from 'antd'
import { useDispatch } from 'react-redux'
import { setGraphCreatingEdge } from 'Actions/graph'
import { NodePicker, RelationPicker } from 'Components'
import { getNamespaces } from 'Services/WeaverUtils'
import { useEffect, useState } from 'react'
import { splitUid } from 'Services/WeaverUtils'
import Feather from '@sysunite/react-feather'

export default ({ data }) ->
  dispatch = useDispatch()
  [loading, setLoading] = useState(true)
  [sources, setSources] = useState([])
  [relKeys, setRelKeys] = useState([])
  [targets, setTargets] = useState([])
  [initialData, setInitialData] = useState([])

  useEffect(->
    (->
      setLoading(true)
      fromNodes = []
      toNodes = []
      if edgeData = data?.edgeData
        if edgeData.from? and edgeData.to?
          setSources([edgeData.from])
          setTargets([edgeData.to])
        else if edgeData.from? and not edgeData.to?
          if typeof edgeData.from is 'string'
            setSources([edgeData.from])
          else
            setSources(edgeData.from)
        else if edgeData.to? and not edgeData.from?
          if typeof edgeData.to is 'string'
            setTargets([edgeData.to])
          else
            setTargets(edgeData.to)

        if edgeData.from?
          fromNodes = await new Weaver.Query().restrict(edgeData.from).find()
        if edgeData.to?
          toNodes = await new Weaver.Query().restrict(edgeData.to).find()

        setInitialData([
          fromNodes...
          toNodes...
        ])

      setLoading(false)
    )()

    undefined
  , [data])

  getRelationNamespaceKeys = (keys) ->
    keys.map((key) ->
      namespace = _.findKey(getNamespaces(), (ns) -> key.includes(ns))
      if namespace? then "#{namespace}#{key.split(':')[1]}" else key
    )

  close = ->
    dispatch(setGraphCreatingEdge(undefined))
    setSources([])
    setRelKeys([])
    setTargets([])

  onCreate = ->
    data.promise.resolve({
      sources,
      relKeys,
      targets
    })
    setSources([])
    setRelKeys([])
    setTargets([])

  Footer =
    <Button
      type='primary'
      onClick={onCreate}
      disabled={
        sources.length is 0 or
        relKeys.length is 0 or
        targets.length is 0
      }
    >
      Create
    </Button>

  if loading
    <div></div>
  else
    <Modal
      title='Create relation'
      maskClosable={false}
      onCancel={close}
      destroyOnClose={true}
      visible={data?}
      centered={true}
      mask={false}
      footer={Footer}>

      <Space style={{ width: '100%' }} direction='vertical'>
        <Row align="middle" gutter={8}>
          <Col>
            <Feather type="circle" style={{ color: '#333' }} />
          </Col>
          <Col flex={1}>
            <NodePicker
              initialData={initialData}
              defaultValue={sources}
              placeholder="Source nodes"
              mode="multiple"
              onSelect={setSources}
              style={{ width: '100%' }} />
          </Col>
        </Row>

        <Row align="middle" gutter={8}>
          <Col>
            <Feather
              type="arrow-down"
              style={{ color: '#333' }} />
          </Col>
          <Col flex={1}>
            <RelationPicker
              style={{ width: '100%' }}
              onChange={(keys) ->
                newKeys = getRelationNamespaceKeys(keys)
                setRelKeys(newKeys)
              }
            />
          </Col>
        </Row>

        <Row align="middle" gutter={8}>
          <Col>
            <Feather type="circle" style={{ color: '#333' }} />
          </Col>
          <Col flex={1}>
            <NodePicker
              initialData={initialData}
              defaultValue={targets}
              placeholder="Target nodes"
              mode="multiple"
              onSelect={setTargets}
              style={{ width: '100%' }}
            />
          </Col>
        </Row>

      </Space>

    </Modal>
